export const leapYear = (year) => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

export const isLeapyear = leapYear(new Date().getFullYear());
export const FABRUARY_DAYS = isLeapyear ? 29 : 28;

export const getCurrentLocalDateTime = (
  myDate = new Date(),
  timeZone = "Asia/Bangkok"
) => {
  const options = { timeZone };
  const current = new Date(myDate);
  const currentDate = current.toLocaleDateString("th-TH", options);
  const currentTime = current.toLocaleTimeString("th-TH", options);
  const splitDate = currentDate.split("/");
  const splitTime = currentTime.split(":");
  const date = splitDate[0];
  const month = splitDate[1];
  const year = +splitDate[2] - 543;
  const hours = splitTime[0];
  const minutes = splitTime[1];
  const seconds = splitTime[2];
  const day = new Date(
    year,
    +month - 1,
    +date,
    +hours,
    +minutes,
    +seconds
  ).getDay();
  const timestamp = new Date(
    year,
    +month - 1,
    +date,
    +hours,
    +minutes,
    +seconds
  ).getTime();
  const currentFormatLocalDate =
    pad(year) +
    "-" +
    pad(month) +
    "-" +
    pad(date) +
    "T" +
    pad(hours) +
    ":" +
    pad(minutes) +
    ":" +
    pad(seconds) +
    "+07:00";
  const dateTime =
    pad(year) +
    "-" +
    pad(month) +
    "-" +
    pad(date) +
    "T" +
    pad(hours) +
    ":" +
    pad(minutes) +
    ":" +
    pad(seconds);
  const dateTimeLocal =
    pad(year) +
    "-" +
    pad(month) +
    "-" +
    pad(date) +
    "T" +
    pad(hours) +
    ":" +
    pad(minutes);
  let fullDate = `${year}-${pad(+month)}-${pad(+date)}`;
  return {
    fullDate,
    day,
    date,
    month,
    monthIndex: month - 1,
    year,
    hours,
    minutes,
    seconds,
    timestamp,
    isoDateTime: currentFormatLocalDate,
    dateTimeLocal: dateTimeLocal,
    dateTime: dateTime,
  };
};

export const pad = (number) => {
  if (parseInt(number) < 10) {
    return "0" + parseInt(number);
  }
  return number;
};

export const months = [
  { month: "January", days: 31, index: 0, monthTh: "มกราคม" },
  { month: "February", days: FABRUARY_DAYS, index: 1, monthTh: "กุมภาพันธ์" },
  { month: "March", days: 31, index: 2, monthTh: "มีนาคม" },
  { month: "April", days: 30, index: 3, monthTh: "เมษายน" },
  { month: "May", days: 31, index: 4, monthTh: "พฤษภาคม" },
  { month: "June", days: 30, index: 5, monthTh: "มิถุนายน" },
  { month: "July", days: 31, index: 6, monthTh: "กรกฎาคม" },
  { month: "August", days: 31, index: 7, monthTh: "สิงหาคม" },
  { month: "September", days: 30, index: 8, monthTh: "กันยายน" },
  { month: "October", days: 31, index: 9, monthTh: "ตุลาคม" },
  { month: "November", days: 30, index: 10, monthTh: "พฤศจิกายน" },
  { month: "December", days: 31, index: 11, monthTh: "ธันวาคม" },
];

// const getDateTh = (localDate = new Date()) => {

//   const pad = (number) => {
//     if (parseInt(number) < 10) {
//       return "0" + parseInt(number);
//     }
//     return number;
//   };

//   const timeZone = "Asia/Bangkok"
//   const lapLocalDate = new Date(localDate)

//   const currentDateString = lapLocalDate.toLocaleDateString("th-TH", { timeZone })
//   const currentTimeString = lapLocalDate.toLocaleTimeString("th-TH", { timeZone });

//   console.log(currentTimeString)
//   const splitDate = currentDateString.split("/");
//   const splitTime = currentTimeString.split(":");
//   const date = splitDate[0];
//   const month = splitDate[1];
//   const year = +splitDate[2] - 543;
//   const hours = splitTime[0];
//   const minutes = splitTime[1];
//   const seconds = splitTime[2];

//   const day = new Date(
//     year,
//     +month - 1,
//     +date,
//     +hours,
//     +minutes,
//     +seconds
//   ).getDay();
//   const timestamp = new Date(
//     year,
//     +month - 1,
//     +date,
//     +hours,
//     +minutes,
//     +seconds
//   ).getTime();

//   const currentFormatLocalDate =
//     pad(year) +
//     "-" +
//     pad(month) +
//     "-" +
//     pad(date) +
//     "T" +
//     pad(hours) +
//     ":" +
//     pad(minutes) +
//     ":" +
//     pad(seconds) + "+07:00";

//   let fullDate = `${year}-${pad(+month)}-${pad(+date)}`;

//   return {
//     fullDate,
//     day,
//     date,
//     month,
//     monthIndex: month - 1,
//     year,
//     hours,
//     minutes,
//     seconds,
//     timestamp,
//     isoDateTime: currentFormatLocalDate,
//   };
// }
